import { useLazyQuery, useQuery } from "@apollo/client";
import { VISIT } from "../visit.queries";
import { VisitQuery, VisitQueryVariables } from "../../../__generated__/VisitQuery";

export const useVisit = (id: number) => {
  return useQuery<VisitQuery, VisitQueryVariables>(VISIT, { variables: { id } });
};

export const useLazyVisit = () => {
  return useLazyQuery<VisitQuery, VisitQueryVariables>(VISIT);
};
